import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../firebase';

function SifreGiris() {
  const navigate = useNavigate();

  // Sistem (mağaza) girişinde tek şifre var.
  // Güvenli doğrulama için bir "referans şube hesabı" ile şifreyi kontrol ederiz.
  // Şube hesaplarının şifresi aynı olacağından bu doğrulama yeterlidir.
  const [verificationEmail] = useState('kavakli_sube@ukba-kasa.online');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // 1) Mağaza şifresi doğrulaması (Firebase Auth üzerinden)
      await signInWithEmailAndPassword(auth, verificationEmail, password);
      await signOut(auth);

      // 2) Şifre doğruysa sadece session'da tutup şube seçimine geç
      sessionStorage.setItem('UKBA_STORE_PASSWORD', password);
      navigate('/subesecimi');

    } catch (err) {
      console.error(err);
      setError('Hatalı şifre, lütfen tekrar deneyin.');
      sessionStorage.removeItem('UKBA_STORE_PASSWORD');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="ukba-login-page"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        fontFamily: "'Helvetica Neue', sans-serif"
      }}
    >

      {/* Form Kutusu */}
      <form
        onSubmit={handleSubmit}
        className="ukba-login-card"
        style={{
          padding: '50px',
          borderRadius: '15px',
          background: '#ffffff',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          width: '420px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >

        {/* Başlık */}
        <h2 style={{
          fontSize: '26px',
          marginBottom: '10px',
          color: '#111',
          fontWeight: '700'
        }}>
          Sisteme Giriş
        </h2>
        <p style={{ color: '#666', fontSize: '14px', marginBottom: '30px' }}>
          Devam etmek için mağaza şifresini giriniz.
        </p>

        {/* Şifre Input */}
        <div style={{ width: '100%', marginBottom: '20px', textAlign: 'left' }}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Şifre"
            required
            autoFocus
            style={{
              width: '100%',
              padding: '16px',
              borderRadius: '8px',
              border: '2px solid #eee',
              backgroundColor: '#fafafa',
              fontSize: '18px',
              outline: 'none',
              boxSizing: 'border-box',
              transition: 'border-color 0.3s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#000'}
            onBlur={(e) => e.target.style.borderColor = '#eee'}
          />
        </div>

        {/* Giriş Butonu */}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '16px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: '#000',
            color: '#fff',
            transition: 'transform 0.1s ease',
            marginTop: '10px'
          }}
          onMouseDown={(e) => !loading && (e.target.style.transform = 'scale(0.98)')}
          onMouseUp={(e) => !loading && (e.target.style.transform = 'scale(1)')}
        >
          {loading ? 'KONTROL EDİLİYOR...' : 'GİRİŞ YAP'}
        </button>

        {/* Hata Mesajı */}
        {error && (
          <div style={{
            marginTop: '20px',
            padding: '12px',
            backgroundColor: '#fee2e2',
            color: '#dc2626',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            width: '100%',
            boxSizing: 'border-box'
          }}>
            {error}
          </div>
        )}
      </form>

      <div style={{ marginTop: '20px', color: '#999', fontSize: '12px' }}>
        UKBA KASA SİSTEMİ v2.0
      </div>
    </div>
  );
}

export default SifreGiris;
